// src/features/delegations/services/delegations.js
import { apiClient } from '../../../services/api/client';

export const delegationsAPI = {
  getDelegation: (delegationId) =>
    apiClient.get(`/api/v1/delegations/${delegationId}`),

  filterDelegations: (body = {}) =>
    apiClient.post('/api/v1/delegations/filter', body),

  createDelegation: (data) =>
    apiClient.post('/api/v1/delegations/', data),

  createRevision: (delegationId, data) =>
    apiClient.post(`/api/v1/delegations/${delegationId}/revisions`, data),

  signRevision: (delegationId, revisionId) =>
    apiClient.post(`/api/v1/delegations/${delegationId}/revisions/${revisionId}/sign`),

  archiveDelegation: (delegationId) =>
    apiClient.post(`/api/v1/delegations/${delegationId}/archive`),

  getRevisionHistory: (delegationId) =>
    apiClient.get(`/api/v1/delegations/${delegationId}/revisions`),

  getRevision: (delegationId, revisionId) =>
    apiClient.get(`/api/v1/delegations/${delegationId}/revisions/${revisionId}`),

  deleteDelegation: (delegationId) =>
    apiClient.delete(`/api/v1/delegations/${delegationId}`),
};
